<div class="complianceBox">
    <div class="row justify-content-center">
        <div class="col-md-12 col-lg-12">
            <div class="trinka-title mb-0 text-center">
                <h2>國際合規標準</h2>
                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                <p class="text-center">Trinka 嚴格遵守以下國際資訊安全與品質標準</p>
            </div>
        </div>
    </div>
    <ul>
        <li>
            <img src="/assets/images/Hipaa-logo.svg" width="119" height="119" alt="Hippa" />
        </li>
        <li>
            <img src="/assets/images/EU-AI-ACT.png" width="119" height="119" alt="EU AI Act" class="eu-ai-image" />
        </li>
        <li>
            <img src="/assets/images/SOC-2.webp" width="113" height="112" alt="SOC 2" />
        </li>
        <li>
            <img src="/assets/images/compliance-certificate5.svg" width="113" height="112" alt="GDPR" />
        </li>
        <li>
            <img src="/assets/images/compliance-certificate1.svg" width="113" height="112" alt="iso 270001:2013 information security certificate" />
        </li>
        <li>
            <img src="/assets/images/compliance-certificate2.svg" width="113" height="112" alt="iso 9001:2015 quality certificate" />
        </li>
        <li>
            <img src="/assets/images/compliance-certificate3.svg" width="113" height="112" alt="iso 17100:2015 translation service certificate" />
        </li>
        <li>
            <img src="/assets/images/compliance-certificate4.svg" width="134" height="110" alt="ada certificate" />
        </li>
    </ul>
</div>